import Claim from 'pages/layouts/Claim';

const StaticPageHeader = ({title, subTitle}: any) => {
  return <Claim title={title} subTitle={subTitle} bgIcon="none" />;
};

export default StaticPageHeader;
